import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {input} from "../../utils/linker";
import {ComponentContext} from "../../contexts";

function ShortDescription(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext=useContext(ComponentContext);
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const getField=()=>{
    if(props.linker.value.type_code) {
      return compContext.field_types.data[props.linker.value.type_code];
    }
    return null;
  };

  const getShortDescription=()=>{
    const filed=getField();
    console.log("PPP", toJS(props.linker.value), toJS(filed));
    const parts=[];
    for(let i in filed.options) {
      if(typeof props.linker.value[i] !== "undefined") {
        switch(filed.options[i].type) {
          case "select":
            if(props.linker.value[i]) {
              for(let j in filed.options[i].options) {
                if(filed.options[i].options[j].id === props.linker.value[i]) {
                  parts.push(filed.options[i].options[j].name);
                }
              }
            }
            break;
          case "int":
            if(props.linker.value[i]) {
              parts.push(filed.options[i].name+": "+props.linker.value[i]);
            }
            break;
          case "string":
            if(props.linker.value[i]) {
              parts.push(props.linker.value[i]);
            }
            break;
          case "bool":
            console.log("BOOL", toJS(props.linker.value[i]), toJS(filed.options[i]));
            if(props.linker.value[i]) {
              parts.push(filed.options[i].name);
            }
            break;
          case "resize":
            if(props.linker.value[i].mode) {
              parts.push(props.linker.value[i].mode);
            }
            if(props.linker.value[i].quality) {
              parts.push(props.linker.value[i].quality+"%");
            }
            break;
        }
      }
    }
    return parts.join(" / ");
  };

  if(!compContext.field_types.inited  || !getField()) {
    return null;
  }






  return (
    <div>
      <input type="text" readOnly={true} value={getShortDescription()} className="bg-w2 w100" style={{background:'#F2F2F2'}}/>
    </div>
  )
};

ShortDescription.defaultProps = {};

ShortDescription.propTypes = {}

export default observer(ShortDescription);
